import { Box } from '@workwhile/ui'
import {
  CalendarView,
  CalendarViewProvider,
  AssignmentWorkflowsProvider,
} from './Calendar'
import { ListView } from './ListView/ListView'
import { ViewToggle } from './ViewToggle/ViewToggle'
import { EditShiftFlow } from '../EditShiftFlow'
import { RequestWorkersFlow } from '../RequestWorkersFlow'
import { useLocation, useNavigate } from 'react-router-dom'
import { AutoBackfillIndicator } from './AutoBackfillIndicator'
import { RemoveWorkerFlow } from '../RemoveWorkerFlow'
import { CancelShiftFlow } from '../CancelShiftFlow'

export const ScheduleView = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const view = location.pathname.endsWith('/list') ? 'list' : 'calendar'

  const handleViewChange = (newView: 'calendar' | 'list') => {
    const basePath = location.pathname.split('/').slice(0, -1).join('/')
    const currentParams = location.search

    if (newView === 'list') {
      // Store current params in sessionStorage before switching to list view
      sessionStorage.setItem('calendarViewParams', currentParams)
      navigate(`${basePath}/list`)
    } else {
      // Restore params when switching back to calendar view
      const storedParams = sessionStorage.getItem('calendarViewParams') || ''
      navigate(`${basePath}/calendar${storedParams}`)
      sessionStorage.removeItem('calendarViewParams')
    }
  }

  return (
    <Box>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={4}
      >
        <Box flex="1" mr={4}>
          <AutoBackfillIndicator />
        </Box>
        <Box>
          <ViewToggle view={view} onViewChange={handleViewChange} />
        </Box>
      </Box>

      <AssignmentWorkflowsProvider>
        {view === 'calendar' ? (
          <CalendarViewProvider>
            <CalendarView />
          </CalendarViewProvider>
        ) : (
          <>
            <ListView />
            <EditShiftFlow />
            <RequestWorkersFlow />
            <CancelShiftFlow />
            <RemoveWorkerFlow />
          </>
        )}
      </AssignmentWorkflowsProvider>
    </Box>
  )
}
